import Flex from '../Flex';

const AsideFilterWrapper = ({ title, children }) => {
  return (
    <Flex className='aside-filters__filter' vertical>
      <p className='aside-filters__subtitle'>{title}</p>
      <Flex className='aside-filters__filter__wrapper' vertical>
        {children}
      </Flex>
    </Flex>
  );
};

export default AsideFilterWrapper;
